/* jshint ignore:start *//* jshint ignore:start */
import { GestureEventListeners } from '@polymer/polymer/lib/mixins/gesture-event-listeners.js';
import * as Gestures from '@polymer/polymer/lib/utils/gestures.js';
import { html, PolymerElement } from '@polymer/polymer/polymer-element.js';
import { CsMixin } from './mixins/cs-mixin.js';

var e = window.nds;
const t = CsMixin,
  a = e.getSlottedChildren,
  r = e.getAncestorByName;

/**
 * `cs-locale-selector` Description
 *
 * @customElement
 * @polymer
 * @demo
 *
 */
class CsLocaleSelector extends t(GestureEventListeners(PolymerElement)) {
  static get properties() {
    return {
      open: {
        type: Boolean,
        value: !1,
        reflectToAttribute: !0,
      },
      theme: {
        type: String,
        value: 'dark',
        reflectToAttribute: !0,
      },
      disabled: {
        type: Boolean,
        value: !1,
        reflectToAttribute: !0,
      },
      value: {
        type: String,
        notify: !0,
        observer: '_valueChanged',
      },
      _text: {
        type: String,
        computed: '_computeText(value, _options)',
      },
      _options: {
        type: Array,
        value: () => [],
      },
      _columns: {
        type: Array,
        computed: '_computeColumns(_options)',
      },
    };
  }

  static get template() {
    return html`<style include="cs-shared-styles-base-common"></style>
      <style>
        :host ::slotted([slot='locale-selector-option']) {
          display: none;
        }

        :host {
          color: var(--cs-dark-color);
          display: block;
          font-size: 15px;
          position: relative;
          z-index: 4;
        }

        :host([open]) {
          color: var(--cs-dark-color);
        }

        :host([theme='light']) {
          color: #a3a3a3;
        }

        :host([theme='brand']) {
          color: #c2c2c2;
        }

        :host([theme='light'][open]) {
          color: var(--cs-light-color);
        }

        :host([disabled]) {
          color: #c2c2c2;
          pointer-events: none;
        }

        :host([theme='light'][disabled]) {
          color: #585858;
        }

        .cs-locale-selector__selected {
          align-items: center;
          display: flex;
          height: 48px;
          justify-content: space-between;
          min-width: 190px;
          padding-left: 24px;
          padding-right: 24px;
          position: relative;
        }

        @media only screen and (min-width: 1456px) {
          .cs-locale-selector__selected {
            height: 60px;
          }
        }

        :host([theme='dark']) .cs-locale-selector__selected {
          background-color: var(--cs-light-color);
        }

        :host([theme='light']) .cs-locale-selector__selected {
          background-color: var(--cs-dark-color);
        }

        :host([theme='brand']) .cs-locale-selector__selected {
          background-color: var(--cs-brand-color);
        }

        :host([theme='dark'][disabled]) .cs-locale-selector__selected {
          background-color: var(--cs-light-color);
        }

        :host([theme='light'][disabled]) .cs-locale-selector__selected {
          background-color: var(--cs-dark-color);
        }

        :host([open]) .cs-locale-selector__selected {
          box-shadow: 0 14px 20px 0 rgba(0, 0, 0, 0.16);
          z-index: 1;
        }

        .cs-locale-selector__selected::before {
          border-radius: 3px;
          border-style: solid;
          border-width: 2px;
          bottom: 0;
          content: '';
          left: 0;
          position: absolute;
          right: 0;
          top: 0;
          transition: border-width 0.1s, bottom 0.1s, left 0.1s, right 0.1s,
            top 0.1s;
        }

        :host([theme='dark']) .cs-locale-selector__selected::before {
          border-color: #c2c2c2;
        }

        :host([theme='light']) .cs-locale-selector__selected::before {
          border-color: #585858;
        }

        :host([theme='brand']) .cs-locale-selector__selected::before {
          border-color: #c2c2c2;
        }

        :host(:hover) .cs-locale-selector__selected::before {
          border-width: 2px;
          bottom: -2px;
          left: -2px;
          right: -2px;
          top: -2px;
        }

        :host([open]) .cs-locale-selector__selected::before {
          border-width: 3px;
          bottom: -3px;
          left: -3px;
          right: -3px;
          top: -3px;
        }

        :host([open]) .cs-locale-selector__selected::after {
          content: '';
          height: 4px;
          left: 0;
          position: absolute;
          right: 0;
          top: -4px;
        }

        :host([open][theme='dark']) .cs-locale-selector__selected::after {
          background-color: var(--cs-light-color);
          border: solid 2px var(--cs-light-color);
        }

        :host([open][theme='light']) .cs-locale-selector__selected::after {
          background-color: var(--cs-dark-color);
          border: solid 2px var(--cs-dark-color);
        }

        :host([open][theme='brand']) .cs-locale-selector__selected::after {
          background-color: var(--cs-access-brand-color);
          border: solid 2px #c2c2c2;
        }

        .cs-locale-selector__selected-text {
          flex-grow: 1;
          margin-left: 8px;
          margin-right: 8px;
          white-space: nowrap;
        }

        :host(:hover) .cs-locale-selector__selected-text {
          color: var(--cs-dark-color);
        }

        :host([theme='light']:hover) .cs-locale-selector__selected-text {
          color: var(--cs-light-color);
        }

        :host([theme='brand']:hover) .cs-locale-selector__selected-text,
        :host([theme='brand'][open]) .cs-locale-selector__selected-text {
          color: #c2c2c2;
        }

        .cs-locale-selector__chevron {
          fill: #a3a3a3;
          flex-shrink: 0;
          height: 16px;
          width: 16px;
        }

        :host([open]) .cs-locale-selector__chevron {
          transform: rotateX(180deg);
        }

        :host([theme='dark'][open]) .cs-locale-selector__chevron {
          fill: var(--cs-dark-color);
        }

        :host([theme='light'][open]) .cs-locale-selector__chevron {
          fill: var(--cs-light-color);
        }

        :host([theme='brand']) .cs-locale-selector__chevron {
          fill: #c2c2c2;
        }

        :host([theme='brand']:hover) .cs-locale-selector__chevron,
        :host([theme='brand'][open]) .cs-locale-selector__chevron {
          fill: #c2c2c2;
        }

        :host([disabled][theme='dark']) .cs-locale-selector__chevron {
          fill: #c2c2c2;
        }

        :host([disabled][theme='light']) .cs-locale-selector__chevron {
          fill: #585858;
        }

        :host([disabled][theme='brand']) .cs-locale-selector__chevron {
          fill: #c2c2c2;
        }

        .cs-locale-selector__items {
          border-radius: 3px;
          border-style: solid;
          border-width: 3px;
          bottom: 49px;
          box-shadow: 0 14px 20px 0 rgba(0, 0, 0, 0.16);
          display: none;
          flex-direction: column;
          left: -22px;
          max-height: 0;
          min-width: calc(100% + 44px);
          overflow-y: auto;
          padding: 12px 0;
          position: absolute;
          transition: max-height var(--cs-interface-expansion) ease-in-out;
          width: 100vw;
        }

        @media only screen and (min-width: 768px) {
          .cs-locale-selector__items {
            flex-direction: row;
            left: auto;
            max-width: calc(100vw - 48px);
            min-width: calc(100% + 56px);
            overflow-y: hidden;
            right: -28px;
            width: auto;
          }
        }

        @media only screen and (min-width: 1024px) {
          .cs-locale-selector__items {
            max-width: 1192px;
          }
        }

        @media only screen and (min-width: 1456px) {
          .cs-locale-selector__items {
            bottom: 61px;
            padding: 21px 5px;
          }
        }

        @media only screen and (min-width: 768px) {
          .cs-locale-selector__items[data-column-count='2'] {
            width: 484px;
          }
        }

        @media only screen and (min-width: 768px) {
          .cs-locale-selector__items[data-column-count='3'] {
            width: 676px;
          }
        }

        @media only screen and (min-width: 768px) {
          .cs-locale-selector__items[data-column-count='4'] {
            width: calc(100vw - 60px);
          }
        }

        @media only screen and (min-width: 1024px) {
          .cs-locale-selector__items[data-column-count='4'] {
            width: calc(100vw - 128px);
          }
        }

        .cs-locale-selector__select {
          appearance: none;
          background: var(--cs-light-color);
          border: 0;
          color: var(--cs-dark-color);
          font-family: inherit;
          font-size: var(--cs-theme-dropdown-font-size-mobile);
          height: 100%;
          left: 0;
          line-height: var(--cs-theme-dropdown-line-height-mobile);
          margin: 0;
          opacity: 0;
          outline: 0;
          padding: 0 36px 0 24px;
          position: absolute;
          top: 0;
          width: 100%;
        }

        :host([theme='light']) .cs-locale-selector__select {
          background: var(--cs-dark-color);
          color: var(--cs-light-color);
        }

        :host([theme='brand']) .cs-locale-selector__select {
          background: var(--cs-access-brand-color);
          color: #c2c2c2;
        }

        :host([theme='brand']) .cs-locale-selector__select option {
          color: #c2c2c2;
        }

        .cs-locale-selector__select option {
          color: var(--cs-dark-color);
        }

        :host([theme='light']) .cs-locale-selector__select option {
          color: var(--cs-light-color);
        }

        @media (min-width: 768px) {
          .cs-locale-selector__select {
            display: none;
          }

          :host([open]) .cs-locale-selector__items {
            display: flex;
            max-height: 493px;
          }
        }

        @media only screen and (min-width: 1456px) {
          :host([open]) .cs-locale-selector__items {
            max-height: 552px;
          }
        }

        :host([theme='dark']) .cs-locale-selector__items {
          background-color: var(--cs-light-color);
          border-color: #c2c2c2;
        }

        :host([theme='light']) .cs-locale-selector__items {
          background-color: var(--cs-dark-color);
          border-color: #585858;
        }

        :host([theme='brand']) .cs-locale-selector__items {
          background-color: var(--cs-brand-color);
          border-color: #c2c2c2;
        }

        .cs-locale-selector__column {
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          margin-left: 24px;
          margin-right: 24px;
        }

        @media only screen and (min-width: 768px) {
          .cs-locale-selector__column {
            margin-left: 0;
            margin-right: 28px;
          }
        }

        @media only screen and (min-width: 768px) {
          .cs-locale-selector__items[data-column-count='2']
            .cs-locale-selector__column {
            width: calc(50% - 44px);
          }
        }

        @media only screen and (min-width: 768px) {
          .cs-locale-selector__items[data-column-count='3']
            .cs-locale-selector__column {
            width: calc(33.3333333333% - 40px);
          }
        }

        @media only screen and (min-width: 768px) {
          .cs-locale-selector__items[data-column-count='4']
            .cs-locale-selector__column {
            width: calc(25% - 39px);
          }
        }

        @media only screen and (min-width: 768px) {
          .cs-locale-selector__column:first-child {
            margin-left: 28px;
          }
        }

        .cs-locale-selector__item {
          align-items: center;
          border-top-style: solid;
          border-top-width: 2px;
          cursor: pointer;
          display: flex;
          height: 47px;
          justify-content: space-between;
          position: relative;
          text-decoration: none;
          white-space: nowrap;
        }

        @media only screen and (min-width: 768px) {
          .cs-locale-selector__item:first-child {
            border-top: 0;
          }
        }

        @media only screen and (min-width: 1456px) {
          .cs-locale-selector__item {
            height: 56px;
          }
        }

        :host([theme='dark']) .cs-locale-selector__item {
          border-top-color: #eaeaea;
        }

        :host([theme='light']) .cs-locale-selector__item {
          border-top-color: #585858;
        }

        :host([theme='brand']) .cs-locale-selector__item {
          border-top-color: #c2c2c2;
        }

        .cs-locale-selector__column:first-child
          .cs-locale-selector__item:first-child {
          border-top: 0;
        }

        .cs-locale-selector__item-text {
          flex-grow: 1;
          padding-left: 8px;
          padding-right: 8px;
          transition: transform var(--cs-interface-expansion) ease-in-out;
        }

        .cs-locale-selector__item:hover .cs-locale-selector__item-flag,
        .cs-locale-selector__item:hover .cs-locale-selector__item-text {
          transform: translateX(8px);
        }

        .cs-locale-selector__checkmark {
          height: 16px;
          max-width: 16px;
          min-width: 16px;
          visibility: hidden;
          width: 16px;
        }

        :host([theme='dark']) .cs-locale-selector__checkmark {
          fill: var(--cs-dark-color);
        }

        :host([theme='light']) .cs-locale-selector__checkmark {
          fill: var(--cs-light-color);
        }

        :host([theme='brand']) .cs-locale-selector__checkmark {
          fill: #c2c2c2;
        }

        .cs-locale-selector__item-current .cs-locale-selector__checkmark {
          visibility: visible;
        }

        .cs-locale-selector__item-flag,
        .cs-locale-selector__selected-flag {
          flex-shrink: 0;
          height: 11px;
          margin-bottom: 2px;
          transition: transform var(--cs-interface-expansion) ease-in-out;
          width: 16px;
        }

        .cs-locale-selector__item[data-value='ar-sa']
          .cs-locale-selector__item-flag,
        :host([value='ar-sa']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAYAAAB24g05AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAGYktHRAD/AP8A/6C9p5MAAAFRSURBVChTpZJBSwJRFIW/GcfRBtGoFMFICiKMoE1RuG3Tqm2L/oJ/oZ/RH2jdpkWroJ0FLVwEQdJCUok0SgspzHGm+8YJdWwRdOBy34N37jvnvKdR2HT5B3S/D+H0oW8Put2T+hrsfyqAcQVCSlgJpsIRPu0umUQSy4xSbzUJ6TqaplF/eYSQ4ROCAzptiocnFCs33D1VWJrLsJLKUms1qL812cqusX9UACvuE4IWjDDH12esZ5aJRSxy6UUMPUSt3SAVm6Gr7AQwVOBK6/c42N6jKjfOTycpN6uUGw9sLOR47rRIx2e5uL2EsOlRFMYtqCG9rh+iI/pEoCjwAtVkrbyPkBUmn1GS31nNExE7thD7rkPUMHn9eOfqvuTZHMXkAKVCYMpBtXRwJQed3Vye09L5HxQoeENUad52kI/YCpAVJj+Sgry359nrUiqLX8gA3/1qfO6d7f02AAAAAElFTkSuQmCC);
        }

        .cs-locale-selector__item[data-value='hk-hk']
          .cs-locale-selector__item-flag,
        :host([value='hk-hk']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABE0lEQVR42mN4ycCAB91GQifAJEj0Z0UlHH0sLgSiXzn5z3MLfqWkvkxN+xGT8DLE/0tY+FNfvxNwDUDR51GRQFEg+hng/2NC349Z8964uL60tgaip4YGrzQ1gVyohpfV1cgagOj327c/du0EMuCqUTQAbYAr/XHtKlDpz1OngOj7qxdAEqjnkZIyEAEZUA1AR4MMC/EHmvFt2TKQ8bPmARlA1V+bioFmA1U/lpBA0QB0N1A1BAGVAu0BqgaScNVABHQbSAMwpIBhAgwBiBdBPoaontD34cEDoAhE9St+fqgGkKdT0yBmQ8IEqAcoBzQY6E646itgGzZDbIAENsTTQKsgtiGHKSSgEDagxeUJbGgzjAEAI4P7ic3eu9cAAAAASUVORK5CYII=);
        }

        .cs-locale-selector__item[data-value='zh-cn']
          .cs-locale-selector__item-flag,
        :host([value='zh-cn']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAA6ElEQVR42mO4zcBwgoHhNhgBGU9dQSRWtBmMQOpeVld/vVv8qq3966bc30+KgeTz3AIgepmaBkTPoyKB6GWI/1NfP6gGoOrfv8L+3AkHSryd4vP1rC+QvOfsCkQvra1vGRhCEJAL0gC062tTMdBgoCKgho8r/X5ec35fFg3RAFf9SEkZqgHiJIi9QD0/DwZCjEc2+4qEBBABBRdANICcC3YiEGGqBpoNREANQDbUSUANENVozoCbDUFA7gKIBmBQwFUDzYYbDzcbiwb8ZgMR0OUoGiCehoQ3RDMcIZsC1YAckXC0ACsiIQDOftxmk2S4SgAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='cs-cz']
          .cs-locale-selector__item-flag,
        :host([value='cs-cz']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABCklEQVR42mPgjDtav/Thly9fvn79CiQ/wcA7GHgFBk+ePoUgBqCGKdtf3br/7u+/f0AEBH/B4A8Y/P79+9evXz9//vzx48f379/v37sP1QC05OjFV8iq0ZR++/YNXQNED9CS33/+YqoGOhhIomvIn/MYqAeraogPr9+8zcDhtwFZAxAda5ryY9Y8IHo9ffrXqVN/TOh71dYOJIHc2wwMCA2lq4+Xzrw2v6T7pbX1Z0PDp4YGrzQ1HykpA9FjCYlX/PxA8RNwDUClQLOBqr9bWMJVAxFQKQQBNQAFUTSgmf1VUQluNgQhNADdA3T3l7BwIHoZ4v/GxRWCgPohCKgUgqAagNRtDHQCBwIA+OVWMrU7rKMAAAAASUVORK5CYII=);
        }

        .cs-locale-selector__item[data-value='dk-dk']
          .cs-locale-selector__item-flag,
        :host([value='dk-dk']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABFUlEQVR42nWRPU/DMBCG8w+6dqVM3cgGykpGPiYQiIGBMiGxwj/shsTKBkTUEYrUJs6HE1c89lG3DJxeRWf7fey7S9RGkfKSxFrb5Au12RS97citu6fnoPXa2uWSxDw8qtl9e3P7dX1VXVyi7OR0C3CA2LW2ByD5Pk67NFVJgso4zqdTdv4Aco0A3fkZx1ibw6MsPsAtwDwA4sY3DAOAuMPd6H2yz9IBdGld4T3W3kfnoyW0rutaa12WpV6tWH5mmQesHXzgNsaIu/GBu6qq0geJAyiJgVCDlAHjxpokoZKP8TgfjfjSzG8P5m6Gm/7wubvzBWd6b4JJ3KItIPOWvgUIU0L4RDy4AXZ+ZFEU6uWVZP6PfgBgLC8Z2uCiVwAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='da-dk']
          .cs-locale-selector__item-flag,
        :host([value='da-dk']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABFUlEQVR42nWRPU/DMBCG8w+6dqVM3cgGykpGPiYQiIGBMiGxwj/shsTKBkTUEYrUJs6HE1c89lG3DJxeRWf7fey7S9RGkfKSxFrb5Au12RS97citu6fnoPXa2uWSxDw8qtl9e3P7dX1VXVyi7OR0C3CA2LW2ByD5Pk67NFVJgso4zqdTdv4Aco0A3fkZx1ibw6MsPsAtwDwA4sY3DAOAuMPd6H2yz9IBdGld4T3W3kfnoyW0rutaa12WpV6tWH5mmQesHXzgNsaIu/GBu6qq0geJAyiJgVCDlAHjxpokoZKP8TgfjfjSzG8P5m6Gm/7wubvzBWd6b4JJ3KItIPOWvgUIU0L4RDy4AXZ+ZFEU6uWVZP6PfgBgLC8Z2uCiVwAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='nl-nl']
          .cs-locale-selector__item-flag,
        :host([value='nl-nl']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAA7klEQVR42mP4wcBADHoJQyDOv8o2ZPQrJx+KUlKB6EdMAhR5hCE0ICQ8wqAkDH3Xt4cgqIaviko/Zs371zgBhIA2QEi4PUBLcvIhZgEZYA2fPv0Dg79///7+8/f379+/fv368uUfhERDFy9fZnj37h1Ewx8wgGgAkj8g4CsIfPny5dOnT0AGQgOyaiCAKP727RtcNRB8/vwZpEFMo7d05rX4pr1A5FV5yrV3I5A0zt0ER3KZSyEkUJyBwYSBgSU2c/Id/bplmOogiMNvAwQBBcCsGHviZu+D2ABEEBsgmjGNgGoAWgIl0RBQGkIiIQCOfSzbVgVcNQAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='en-au']
          .cs-locale-selector__item-flag,
        :host([value='en-au']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABT0lEQVR42mWRPUvDUBSG7xD8Cc5O4uTkXlBwcHIRXEpd/FgKEXQKIoZiFRUqVuIgKChdYsXaQaSoYKmoS1tLKwhBsFJJBt3E0edwbfyCl5uTe8/z3vck6spOry8fqu54oqsfdfasmZHRnZkVZURDDY3tSaH6RJGR7Vbxtvn81ipcNNycd175aNT38/ezS6coZp8VLuvVWo2dmJkV4FqpYDHpW5Y/PoFe4ia6mZzmeHjqCG8YuvHlVQBi4O0fuMJY1nsm462m8vYWx45bAaAV6TsF4OGX79zdIsOg9EkAf7yZo5swiO45p6RrARiRoQnAmkzMY4wFNd46d+/gBnXKKcvoMrcRxYADHVrnxlWvdLNym8aU0SGAfA0zi1+pGrAb5taAGlhg1eQv4OHxNQgCzH52a2M2wf4C7HLD/2zM+tT0mOEb+JL+kaE4a0uCtetPJnnvAGarUGAAAAAASUVORK5CYII=);
        }

        .cs-locale-selector__item[data-value='en-ca']
          .cs-locale-selector__item-flag,
        :host([value='en-ca']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABZ0lEQVR42lWRvUvDQBjG78/IrFMn7aZ0cBBHPyal3XUrVFyUTjrURaRLFwdx6qKbo4ODFUSoolXxA9uitDUHDZqk+Whi8JekVHo8HG+O5/fe816Eu7SoplL21LRMJAzD6Ok6onAcxzQNXdellG9CxLoSQtgTM1a5jHqlUhAEvu97ngdjyy8K13Uty+pkcz8b6+whQHvcTnFfzedjoN/vy8Iunz2WFW712bnW/MIAiG8AcDe3aOk8Paq39+rqWieTbl9ct8/OiUdTGA5DwEgmnYNDWnKp5/9ySoEoED7GeJ1MUtDiFIBZAZzCDjcS5n2vaC6vYGUPTdmcpmkAaAB8jI0zLokxEcnrdjGROAydSTfqDYAHRQHgJAQ+FQUgzmDbtmmaONSTY8SDatCsAVRSRQPQj9cEIHTr+eW72cQqowVAEBIeieh3BNtFIpGEJwfgWbTRFQ/9Dwz/4l2tVr2pxrqsVIbCN9QfN7JX66mNmtwAAAAASUVORK5CYII=);
        }

        .cs-locale-selector__item[data-value='fr-ca']
          .cs-locale-selector__item-flag,
        :host([value='fr-ca']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABZ0lEQVR42lWRvUvDQBjG78/IrFMn7aZ0cBBHPyal3XUrVFyUTjrURaRLFwdx6qKbo4ODFUSoolXxA9uitDUHDZqk+Whi8JekVHo8HG+O5/fe816Eu7SoplL21LRMJAzD6Ok6onAcxzQNXdellG9CxLoSQtgTM1a5jHqlUhAEvu97ngdjyy8K13Uty+pkcz8b6+whQHvcTnFfzedjoN/vy8Iunz2WFW712bnW/MIAiG8AcDe3aOk8Paq39+rqWieTbl9ct8/OiUdTGA5DwEgmnYNDWnKp5/9ySoEoED7GeJ1MUtDiFIBZAZzCDjcS5n2vaC6vYGUPTdmcpmkAaAB8jI0zLokxEcnrdjGROAydSTfqDYAHRQHgJAQ+FQUgzmDbtmmaONSTY8SDatCsAVRSRQPQj9cEIHTr+eW72cQqowVAEBIeieh3BNtFIpGEJwfgWbTRFQ/9Dwz/4l2tVr2pxrqsVIbCN9QfN7JX66mNmtwAAAAASUVORK5CYII=);
        }

        .cs-locale-selector__item[data-value='en-gb']
          .cs-locale-selector__item-flag,
        :host([value='en-gb']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABQklEQVR42mWRsUtCURTG7+Df0NwkbeESuTa25NAQgdiQ1hIELi0hPKRNcXk8cK3J0KxoihqCN2dDBIG0pnBdRDJf9+LvduAmdPl4HM4533e+c55qRM938edpFBeCB8H7x6i1WwYEucMuWNvukCdDm7q4fUuu2tZaysSAeBKG00bdWIscuH96nQTl5MdElz0FNX4ZwgHGGMr0zfaLAOZJJSYPmRitpZWaI8Cjr//Ym54F9vfR/Z3bkiDRGkVcQXYEnNh/j24hLD4mw1SswkTxIH0eX+vZcSbjv2SqyxuLE4wXk6Y/bZMI3ATMsQC3c6trLbuKpCffhNe439w7V+kjR2B97sPGeCsct/0EJKnyJa8PdtBVqbziRHTQzbG5A8CC7ECr/DhKxINiCTnFz2NvxjFUgDeWA84xkthI5dOrTaSpzgHPM2cUphkv7gAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='en-us']
          .cs-locale-selector__item-flag,
        :host([value='en-us']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABVElEQVR42l2RP0vDQBjGb3DQT9BZN3Wqky46FZysk4iC4D8UOwgWxE5CEN3EwVkcXBQHEbSgm7RLv4AtUihqKkQTay5n7hpTfC4Xz9Dj4eUuee73vLxH1nMPi0v3qGqTFDPyn9vz1eVJe20WVYnAF/yEl3fvuh4XrSAIUMMwxIYzpnV2fiovwDdeEFnDQ9Ua2eRip9BeWRXTWZHJ+KNj/OhQJiBawjodmHzfR3UcB+6erQ9Kqeu6TrSC9gz+lkul/wQNVu6+hbJmQ2x4iO8bcQL6htX+8mAFDO7nl3rv1BW+4GhF69U0W9+seHMdt9TFhpsM3gJM02mwWf+AlJE/2ZgggCEB/QHgebLppt1UfVt/C3izWms1Ggd7uwT3RKWSHIjqW4IjNieEplJQnPBYe8K4gRdCcM4RhRw1dea6LJrSm+UBj17wjqTrIZMCD/ViToK1fgEIGF+0KWM5dQAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='fi-fi']
          .cs-locale-selector__item-flag,
        :host([value='fi-fi']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAA90lEQVR42m2RPQrCQBSE43G8gWfwAB7ATvACVmKtnQewsrNVEDvBRlAUFfEHRBSUFBE2m8QkbnB2X3wGcfgIm2Rm83Zi3WzJWPkBsT854HJ90AJsdwcwGm8s+JKP6t0zoZIkfqnYKAzDp5GUyXK1SgPKUGkfQbm5U0q7oygidxAEvu9jMVnaOkBuCFbix+qRfE+PhIkxA+8NSo01U6xNC9UFgVsr1/oGftywEv8Df91sJfBEB1AZCsHQKIHdWIMn5hYCOEZCCH0GBFBJZMRD6xN7npTSdV2RURqgBtEJt8TlZDP4SBrgH6lHNPQnd7ybzWe4ZukMe2/PfI0FyyvabgAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='fr-fr']
          .cs-locale-selector__item-flag,
        :host([value='fr-fr']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABCUlEQVR42mMonXkNiDIn34GQt+6/u3/v/sXLl4Ho7LmzQPSKn/8lA8NtBoaXYMQAVHf04is4+gEG38HgCwh8/jGh7+vUqT/amoDoNlzD1qMvIOjdu3evkMCTp0+/NhV/LC58XxaNRcOaXa8hGuDagBogqt+mRwB1gjQkdd9E04BsCVADRDUQAXVCNUCUAtGSzdeBjn4HAxA9ENXPoyKBOkCs4pv2QowHqgaiT58+odkAUf0yxP95bsEJoIawxitw1UCEphqIIKqBCKjzBNwGoNIp219NX30BTfWjx3chqt+4uEI1BGRsgHsAqw1wT0M1GOduMgtZB0Ecfhu2b90EQUtWLoAgoCJkBABwtXFCOK2MzAAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='de-de']
          .cs-locale-selector__item-flag,
        :host([value='de-de']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABCElEQVR42mPw9XJARvb2BvgRA1DR9q2bkNGSlQvQUHtLPYRCsAByICgjJRUZIdsMlAUyGArsI/ZumTa/pBvIh5CdsSA0L8seKIWMoDZscLT4vX7tz4rKXzn5v1JSgehHTMLb9IifAf5vXFyB5HcLy8+mmq80Nb82FQMVY9HwJSwcqO6nqysQvbS2hqgGovdl0QgNmKqBxgPRZ0NDiOrHEhJQG1Z3av08s/rrplwg+rjSD47eTvF5062NjIAKoBr+vl/8+1fY17vFHx74/bkTDiR/XnP+dtEAyACSQPTptDwQPboaAVTMcOiQD1DD9xd9aOj3k2KgEUAEVAdhABEw6EA24EdARcgkAMhYEh1utyQwAAAAAElFTkSuQmCC);
        }

        .cs-locale-selector__item[data-value='hu-hu']
          .cs-locale-selector__item-flag,
        :host([value='hu-hu']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAA2UlEQVR42mM4wcCAB21GRQsYwKIvq6vh6GNx4fPcAgh6mZoGRM+jIl+G+APRU18/hAagKBwBJYDonrMrBN0yMIQgIHszpgZcqiCsQDb8+/f3Hxj//vP3169fEBIIfvz48R0MPnz7+gkMvn79+uTpU4a/f8Cs/v798+cPXPXPnz8hGr59+wZU9+XLl8+fPyM0QFSDNPz+jUs1EAAZIA0MYUzZm7LdZ7lBkMkEY2TE1cQDR0AuAwsbSEPi6kRcqpH1IDTEzY0B6glZEgJBcM2YRoA16GEgoChuBABTKwjbtZPVLgAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='india']
          .cs-locale-selector__item-flag,
        :host([value='india']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABAElEQVR42mP4vYsBP3o9E0pCEFj0STEm+nq3+M+dcGT04YEfVMP3F31ocj+vOcPRt4sGEARkgzQAWX/fLwbqgaNrZ6euXnB4/s41QAbEKjgCms7w9+/ff/9ACAL+/PmzZPP16asvHL34Ckh+A4PPYPD245cnT58yQNT9/vP3NwwA1e0+dLW0Y+eE6ee/fv365csXoOpPnz4B2Sga/oDBj69fgWbXTj8KREBtX8AAogHIAGlgCGOqOjEhe1M2ECWuToSgkCUhEOQ+yw2CTCYYA8UZ9BgYuJp46vbW4VcN0QAUAWkA2gDUAEFAbeXry3HZBtUAtAGoBx0BJTARCxuQBACVx0N0KMpSuAAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='it-it']
          .cs-locale-selector__item-flag,
        :host([value='it-it']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAA50lEQVR42nWRMQ/BQBSAL0aRdDQzMnVjJWam1iDiV4jE5g+ZLSYSC6vIhSbowFrX3rXVeL0Xjza8fOn0fb17LSvOSt84Jwe4uu75cgT2By4ZQ24aBtJ0MyGSJHnqieKUMAzlYPSwbED1up+gv7CRpw7iOI6iCGylVNBoeqYp6rU/QdaGQVtUqqrT+RGAR7aUMggCtAE4Kh+0562cnQba9srlTAAqAouS7fu+gNF2JhguxxTkbSFAvRtG2pgmxwAvgwhfkP3QgwEAy3A6gZamq1MDL8YP9TmBWQViu9uuVyt8Ilz/YP7mBVsTOUQfESu+AAAAAElFTkSuQmCC);
        }

        .cs-locale-selector__item[data-value='ja-jp']
          .cs-locale-selector__item-flag,
        :host([value='ja-jp']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABDElEQVR42m2RMU7DQBBFfRUoQ5WOHCA1VNBQcAxyAW6QhoIbIGq4Q5BQBBGKQiRIGqQgtPasd21s8XYn2Abl68uN3x/PfCfGGOec916s4CzL0jT97OgjarVe47f3RSIidV1X0aoq6juqLMuiKBjH0DzPl6/LbaCjyt3f1aNLfzEqb28a1Fq7I8DgAA2H6vxwIOMxAWgwnrOXeRsI9Gbjj48aWu2en2C4jWcIcKLSbMy7Lp32+3LQY0NtgsDjdJrQktLcF77wS4OqmQIN1ga2dCyEpVt6b5/Tv6yYKGIhQNMEiigf5a6u3dl5dnJK2PzV5GESAk3ZWqLW4kT0Vt2nDfz7kTSNaUPNDmpQ9Q8de8Ify+OPnAAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='ko-kr']
          .cs-locale-selector__item-flag,
        :host([value='ko-kr']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABU0lEQVR42mWRzUrDQBSF+0yuhG7NxrdQFAoKXblwJRTRF3AjuOiiGxERlOLCnTYuhIol2CKiBdOgpjVqMpNMflr8kilWcDgMd+6cc++5M6WvUP7Hx7fQ8DzPGQ41Bo7zYj+VuJ4Uq/fwaLZaQohxsbIsS7NxEATnzdP2bTuO4zAMZwLXdXe3twAy2Kp7D5Ik4VhZWdV5BNavgDNZiikp1U4tNgxAgCuSaGgupew/92eWaEKcnhxr9mjBeC+X0by6gnJ4Q0AwFWjfmD6qX8GDXVm7XFq+uK7tKaUYDAF7LqBpzswyOpBvmm+LmzdQ59fvQOOsZw8+4fm+j6BjWbkgTVMiZmgc1oWYbOx356oKdvXAxg9JZmASvEwFlGcaBFyQ4jXMjgsoyYOS1EPrY4mvwToDkaIMxqIowjcyGHwWHcj7xco7/P1InlnvNMS3BiQKAx38AE1DsSNDguf/AAAAAElFTkSuQmCC);
        }

        .cs-locale-selector__item[data-value='pt-br']
          .cs-locale-selector__item-flag,
        :host([value='pt-br']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABDklEQVR42mNgCGPCh/QYoCQcAfnVJyogqG5vHQRtuB8MRNmbsoEocXUiBIUsCYFqAKqAywFFf/8KgyP3WW5AZDLBGIhAGljYoDZAVANNBSrKL/xkV/kTiICMb18NZ5wTRtcAtCFiZzjEyMvntjx+8h6Ith59YZT/I75gLVAPEAE1OK93QtgAd0NS902Q2XMer9n1+ujFV/VLH4I1iAJR2a4IFBuAEkANEzvXAQ0G6gGSQD1LVi6AqDafLgK0BKoB6AGg+4AI6AegNqDTgaqBCOwHUaAfuJp4gAjoe4QGSGgAEdChQD0fHvgBEVA10FSgUjgJ1qDHgBymQATUBokHSIDCgxWhAT0ugQgogQMBAM8n1yv5YwVsAAAAAElFTkSuQmCC);
        }

        .cs-locale-selector__item[data-value='es-mx']
          .cs-locale-selector__item-flag,
        :host([value='es-mx']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABJUlEQVR42m2QvUvDUBRHg6P4t4jOHRxEcNFRUGcFBcVVBwURdHTRRdAOIggOgl0U3Cp0aSFkEBVTUGxpoEGDr/loXvE0V9IoeRwud/idd+97hjE3BMO7I9K4rus4DrXRbkDdrlcMI4tBaPvuKKUba627utfrV60DpZprG62lZak3ImxVDtevD2DxYjMMQ3JxHGNGUYTwMTML9uTUQOBiokKUHNs0rVpJdRQCUaG5MJ8j+L5P9L50fLo6QeN5nqRbhUKOMH2ywkpv768I+3s7NCoRnsfGgcV+BdleBCacXxbPbq+owHdJOkcgDTyAiyVNw0qpwKiBIGlof30HQfDZUUA6OwGh+G8l4GfYitpHqfTRQjJh9A+mZT0+vVChWqs+lMuEsvwArvkr0rRX6H0AAAAASUVORK5CYII=);
        }

        .cs-locale-selector__item[data-value='no-no']
          .cs-locale-selector__item-flag,
        :host([value='no-no']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABOklEQVR42mWRPUvDUBSG76ijW2adurVzR+2oLiIqIiJWESpVXJQO4uyoo6u/IIP+AcEf0EUrgoZQktpg0WiS5gaf3KPx6/JwuDl533PvOVd5SnWUIg5TPbpylWVZx2SE6x8bIf+I9w+8Vgvp6YWvtR7s7Xa3d5JG06tvQLS82l1a9OZmITdQGzVZDIfnD1mm+eFOzzxN1cCrVsGtlP1SieT3Cf3NBW0MXOy/Wgz3kzUbAzoBKYY0TYdmxXEcRdG7WS9mRWHo+76iUa6OFJpnjrB1cgdrxzfC/FEbyIyMXebDKUBaFCY+v4X9wStRYJ+fQA/MhHsnSYIBXXHvx/EJaFuWY1lEMrY0nazXaREDh1L7tlwp1I5Ro/llYNhMGgNtYJApMRMoTgMKfRrkIYMgoCe315MXtb/iHz4AESQv/etWU50AAAAASUVORK5CYII=);
        }

        .cs-locale-selector__item[data-value='nb-no']
          .cs-locale-selector__item-flag,
        :host([value='nb-no']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABOklEQVR42mWRPUvDUBSG76ijW2adurVzR+2oLiIqIiJWESpVXJQO4uyoo6u/IIP+AcEf0EUrgoZQktpg0WiS5gaf3KPx6/JwuDl533PvOVd5SnWUIg5TPbpylWVZx2SE6x8bIf+I9w+8Vgvp6YWvtR7s7Xa3d5JG06tvQLS82l1a9OZmITdQGzVZDIfnD1mm+eFOzzxN1cCrVsGtlP1SieT3Cf3NBW0MXOy/Wgz3kzUbAzoBKYY0TYdmxXEcRdG7WS9mRWHo+76iUa6OFJpnjrB1cgdrxzfC/FEbyIyMXebDKUBaFCY+v4X9wStRYJ+fQA/MhHsnSYIBXXHvx/EJaFuWY1lEMrY0nazXaREDh1L7tlwp1I5Ro/llYNhMGgNtYJApMRMoTgMKfRrkIYMgoCe315MXtb/iHz4AESQv/etWU50AAAAASUVORK5CYII=);
        }

        .cs-locale-selector__item[data-value='nz-nz']
          .cs-locale-selector__item-flag,
        :host([value='nz-nz']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABH0lEQVR42mM4mV7YGVvPwBLbouAERBDGqqhiIAOEGEygDAgbiMQ0eu/uu3Dv4sVrqzcCEYQ9Yfr5ivqj8QVrgWh+STeQDMjY4JWwGKThioTE16lTX7W1v6yufpma9jy3AMgAkvahc4AIaDnECXpuk6CsgA54tnv/t2XL7vZMAGlbsxrIAJoKlAZqAKqDqAaSQC4DCxsD0Dqghomd6441TQEioGOADgNygdJAn8D1ANlgr7KBbIBIA/kQY4DOBdoAVAd0DFCdmv4sICqwj4DaAPR+fNNeoAOAyCxkHcTpQNUQBFENDBggAnKhGjKyD0E0YKoGkkClQOMhbJgNBWvxqN7gaAF0GFAPigZISEMCG1kzPHAhpkA1QKMQDQHlsCEAskrEz5xtuPwAAAAASUVORK5CYII=);
        }

        .cs-locale-selector__item[data-value='pl-pl']
          .cs-locale-selector__item-flag,
        :host([value='pl-pl']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAAyklEQVR42n2OsQ6CMBRF+weMzDrqxKYfwKyTLg4OsJm46k8YP0/DwmIiJCQSLKVUjJcWKlX05qTDy7mvj1Rp2kUkiYbFV80tDBUE0tNMJfOQKcuSc17I0Jz2FLQthNA2YyzPc7yX09ko/LGpjFHQZ/yym0JBSHE88N2+3GwbPL9YrcF9sQR8PuOuCzCJCKkLkPQUsMkUZI5DxyM6GILMtgGGwUdBqaBWTTu2LKxoC57ftb93wwYYNgV1sTq69za14v2DImrfLkH7al79dWSVyfXhRAAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='pt-pt']
          .cs-locale-selector__item-flag,
        :host([value='pt-pt']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAA/0lEQVR42mNgCGNCQz8YGLCil2DEAFRRvr4cGf3KyYeilFQg+hIWDkE/A/wRGuLmxgDRzEVhhw75/DwY+GajOVD6p6vrdwtLIPpsaPhVWwvIRdHw6GoEEL0vi36bHvFxpR8QIav+qqiErgFoNlD1j2tXX56/BGQALUFWDURALkKD+yw3iIYPDx48fvIeouGNiytc9WdxcZgGPQZkDwCVvmprv3fcHIg+m2rCVaNoyN6UDbQBYglQHcjsjeY3kj0gSoHkK35+kB5Dw9twG4CqTSYYQ9ArTU00s4CsgAjovNvIToJoA5LA0IAgSCghvA7XAEIsbHD0EhapEHQbRkIQAF3v3RlSLHlHAAAAAElFTkSuQmCC);
        }

        .cs-locale-selector__item[data-value='qa-qa']
          .cs-locale-selector__item-flag,
        :host([value='qa-qa']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAAmUlEQVR42mO4ePny0xs3gWj71k217u4EEcOnT5/+g8H1E8eB/GxNbfyI4dWrV0DV//79A2qosLEDCv2HAbgioCy6BiC4d/EiUAOyHEQPmn50DcgGwzXASRQnATUA/UCsBogNmBqQAcS16BpiVVSBEnBHw/XDRVCcBAklNBXowfr24xdkTxOOh6NHjpw9dxYYCcCYBvKBTsKPABURJrTUMt9BAAAAAElFTkSuQmCC);
        }

        .cs-locale-selector__item[data-value='ru-ru']
          .cs-locale-selector__item-flag,
        :host([value='ru-ru']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAA3klEQVR42n3MvQ7BYBQG4LOajGZiECYbq5DYSCQSYnABFdyJS3ABNpvdBVgZDCRNK36q7dcfP/Gmp2k/knrz9KRfe96PLOvNHs+X53k3YfPxbFig6uGEw/EKhH+cV4CDMiB8C+IE2e4vcYHzlOIH4VUhRFio1/3F6jSbOUnG03s0UymD8OAAaPKMFApChi9xQd6LtuUO1v4Vfu7GTvRCSyJ1NFH7vU1NYet8J8mciFwiXxm7za5TqTKzXMa0szkwMxk9nQaNyC4Vd1xwB0PmtVuhRgPkK7AtFQJagt23D78OOlrpRiSPAAAAAElFTkSuQmCC);
        }

        .cs-locale-selector__item[data-value='es-es']
          .cs-locale-selector__item-flag,
        :host([value='es-es']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAA2UlEQVR42mP4wcCAC71EYsARiP+zohKI/lW2QRi/cvKhKCUViH7EJPwM8IcghAagKATB5X66ugLRdwtLIPpsaAhEQC5Iw7evor9/hcHRhwd+QPLbV0MIiYRAyp4+RdXwviz6bXrE9xd9mKohDBQNP3btBKp+ef4SkAG0B0ODKLqGZ2+fvZ3i8zLEH8hA1SCKXcPlc1ten/T+uNJv75ZpGEqRNABDCRh28ACBhMlXba2vikpA9FlcHIhe8fMDEVDwNgNMAzxMv4SFYw1TkBFwDZjRCUG3kRhwBABSdCQSWYwoDgAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='sa-sa']
          .cs-locale-selector__item-flag,
        :host([value='sa-sa']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABEklEQVR42mPgauIBorh9ZRcvX/5saPiDgQE/YphxTrjqxAQgWnBr07O3z74tW/YrJx+EUlIh6EtYOAT9dHUFaVjdqfX7STHQBgi6/PguSE9KKlAagoDWQhBUAwML25E95XA9nhvTgHqAVv08derHrp1o6HluAUhDRkrqzEVhj65G1O2tA2pAQ+bLwyEIyGbQA9vQ3lLv6+UA0VO2KwJZkcIsazgCcqCs4DYgq0bWBtGJsAHoB2TVQD8A0dajL9bseg1ESzZfhzCAKDFpNyiUPjzwg7sYGLgTJnw3N98ORByCO5ARUISBsQcUD5DwAUYF0OCK+qNurpfhCKhIQ+MbnARpYAhjAsY00IlAqyEmgURxIwDL7PZMhaXQjwAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='se-se']
          .cs-locale-selector__item-flag,
        :host([value='se-se']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAAw0lEQVR42mNgcG6Eo9+7GCCIQS0XBbHEQhGDCQNQXenq4xD0+0kxBEG4cbP3ISPX3o1gPWANEKE/d8IhCCgHR/p1yyAIpAFuA7KGn9ecMVUjNIAc/aQYbjZEAwR9u2gAQZ9OywPR17O+r2cyoGiAK8VUDURANooG/KoRGoChBvQDxMVwpXB3y2UuBSKBzFlABOSCPa2WCwkyTA1ARXDV6BrgoQTUAw9WSMggBxQDCxsDKC5gcQl0IgSBTYIhkCIYyWACAJq+AUf+6Io4AAAAAElFTkSuQmCC);
        }

        .cs-locale-selector__item[data-value='sv-se']
          .cs-locale-selector__item-flag,
        :host([value='sv-se']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAAw0lEQVR42mNgcG6Eo9+7GCCIQS0XBbHEQhGDCQNQXenq4xD0+0kxBEG4cbP3ISPX3o1gPWANEKE/d8IhCCgHR/p1yyAIpAFuA7KGn9ecMVUjNIAc/aQYbjZEAwR9u2gAQZ9OywPR17O+r2cyoGiAK8VUDURANooG/KoRGoChBvQDxMVwpXB3y2UuBSKBzFlABOSCPa2WCwkyTA1ARXDV6BrgoQTUAw9WSMggBxQDCxsDKC5gcQl0IgSBTYIhkCIYyWACAJq+AUf+6Io4AAAAAElFTkSuQmCC);
        }

        .cs-locale-selector__item[data-value='sp-sp']
          .cs-locale-selector__item-flag,
        :host([value='sp-sp']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAABCElEQVR42n2QP0vDQBiH8w36HXTKpnNXO6qLKHa2nQoijtky9KN0E2f9BKVbNotQSiG0dxgwJne53LXQ3/1JPDD48nDc5X7PmzcJSBAA2uvZjeWzWX3mZtUX9WIhGFOvL2Iai/c3PpvJySMZjYF8GG2H96C8vUsvr+ZOqGvk8ucnrLggUQTz62IASL8P0vMzGoY4OuGQ59/rNaJw8DbwN705Of0V0FhlGSbR7W+uO9MAx0aYxugN2qGtiaGtbH081wLmUfvD3pRSSkqpP0mIyhTjrCiKH1OMsVWSOEGZ8tOccyTKsmwFbLSA6dFbmvonbcsJbdofptPRQkV3gFKKP2tJP5Y+CPkcAT85clSEXHWSAAAAAElFTkSuQmCC);
        }

        .cs-locale-selector__item[data-value='th-th']
          .cs-locale-selector__item-flag,
        :host([value='th-th']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAA9UlEQVR42mP4wcBAJHoJRmBOWxMQ/atsA5I/Kyrh6FdOPgilpP6ISQCiL2HhIA3/oOAvGP37+/f3nz9/IOSvX79+/Pjx8+dPIPnt2zcg+erVKwYf301LNl+fMP08GqqoPwoh4QjIZWDsYQBiICcxaTdQJwSZm2+HkGr6syAkEIlp9ALZDAwmIA0Z2YfgqiFKMVVzCO4AaWBhY2BgiUXToOc2Ga4HqBRCImwAaoW7FagTjoCORHYnEAG5QNMZfnz9CgkQCACFydevXz99+vvxI4RERvfv3QfFAyLIUUMdiH4G+APRGxfXn66uQPI2A0ZEYqLbqAgAW6cUsnXiqG0AAAAASUVORK5CYII=);
        }

        .cs-locale-selector__item[data-value='tr-tr']
          .cs-locale-selector__item-flag,
        :host([value='tr-tr']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAYAAAB24g05AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAGYktHRAD/AP8A/6C9p5MAAAEuSURBVChTpVK9SgNBEP7mNmcul4h24kmSB7AUfAEbsbGx8TVsU2gEwTewsbfxScRCCAo2Eg0YIsglISZ3udtdd9djUS8kgh8sOzszOz/fDHX8NYl/wMluCykEZBRDpmmmmY8fAWQUQUQhvN0dsGDdvBeBHbmVEy3IeApWr6IadiGHQ1C5DHIY0vazcYTjgIi+5G+wHPBxDzXOMWicon/eVKUtG4el7S2I3hvEewip7L+D2BZ0FFJZxlfXYGwVVCoZ7UqzgaB9Dz7qzqzABtAmTaB/eADO+5CTidEOjs/wWt8EqyhOZH5gtgXDQW0DwVMLo4tLTO9aSNSJb25BrgsUCvM50DBTEB/w9/aRPDyCv3RAnpdZZyO3SLoNJImaDwOprIuQWyRNJBWLf/oMAJ+5mHSXRuZmqAAAAABJRU5ErkJggg==);
        }

        .cs-locale-selector__item[data-value='ua-ua']
          .cs-locale-selector__item-flag,
        :host([value='ua-ua']) .cs-locale-selector__selected-flag {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAAbElEQVR42pWOMQqAMAxFf+9YF3sCFRRPol5HHcVdig6iR2lrQkeXBB4hgff5gXGrCqCc4RYpJHNIHGBZHyh2WCnGbminqhtrIf3QIN1Ij5TwAuFCOqWQjOQVAZIRNQ0kIx5cxI95Ju/5/E+SPydYAG+q8qVFAAAAAElFTkSuQmCC);
        }
      </style>
      <slot name="locale-selector-option"></slot>
      <span
        class="cs-locale-selector__selected"
        on-click="_handleLocaleSelectorClick"
      >
        <span class="cs-locale-selector__selected-flag"></span>
        <span class="cs-locale-selector__selected-text">[[ _text ]]</span>
        <iron-icon
          icon="cs-action-16:chevron"
          class="cs-locale-selector__chevron"
        ></iron-icon>
      </span>
      <div
        id="items"
        class="cs-locale-selector__items"
        data-column-count$="{{ columns.length }}"
      >
        <template is="dom-repeat" items="{{ _columns }}" as="column">
          <div class="cs-locale-selector__column">
            <template is="dom-repeat" items="{{ column }}" as="option">
              <div
                class$="{{ _getLocaleSelectorItemClass(option, value) }}"
                data-value$="[[ option.value ]]"
                data-text$="[[ option.text ]]"
                on-tap="_handleSelectedClick"
              >
                <span class="cs-locale-selector__item-flag"></span>
                <span class="cs-locale-selector__item-text"
                  >[[ option.text ]]</span
                >
                <iron-icon
                  icon="cs-state-16:checked"
                  class="cs-locale-selector__checkmark"
                ></iron-icon>
              </div>
            </template>
          </div>
        </template>
      </div>
      <select
        id="select"
        class="cs-locale-selector__select"
        on-change="_onSelectChange"
      ></select> `;
  }

  /**
   * Instance of the element is created/upgraded. Use: initializing state,
   * set up event listeners, create shadow dom.
   * @constructor
   */
  constructor() {
    super(),
      (this._tapHandler = this._tapHandler.bind(this)),
      (this._setOptions = this._setOptions.bind(this)),
      (this._toggleAttribute = this._toggleAttribute.bind(this)); // jshint ignore:line
  }

  /**
   * Use for one-time configuration of your component after local
   * DOM is initialized.
   */
  ready() {
    super.ready();
  }
  static get observers() {
    return ['_updateSelect(_options)'];
  }
  _computeText(e) {
    // Verificar se o valor existe antes de procurar
    if (!e) return '';

    const t = this._findOption(e);
    return t ? t.text : '';
  }
  _getQueryWithoutParam(e) {
    return window.location.search
      .substr(1)
      .split('&')
      .filter(function (t) {
        const a = new RegExp(`${e}=`);
        return !t.match(a);
      })
      .join('&');
  }
  _getPathnameWithoutSegment(e) {
    return window.location.pathname
      .split('/')
      .filter(function (t) {
        const a = new RegExp(`${e}`);
        return !t.match(a);
      })
      .join('/');
  }
  _setLocale(e, t, a) {
    this.value = e;
    let r = this._getPathnameWithoutSegment('^\\w\\w[-_]\\w\\w$');
    e !== t && (r = `/${e}${r}`); // jshint ignore:line
    let n = this._getQueryWithoutParam(`^${a}`);
    n = '' === n ? `?${a}=${e}` : `?${n}&${a}=${e}`;
    let o = `${r}${n}${window.location.hash}`;
    0 !== o.indexOf('/') && (o = `/${o}`), (window.location = o); // jshint ignore:line
  }
  _computeColumns(e) {
    // Verificar se e é um array antes de processar
    if (!e || !Array.isArray(e)) {
      return [];
    }

    return e.reduce((e, t) => {
      const a = e[e.length - 1];
      return !a || a.length >= 9 ? e.push([t]) : a.push(t), e;
    }, []);
  }
  _toggleAttribute(e) {
    this.hasAttribute(e) ? this.removeAttribute(e) : this.setAttribute(e, ''); // jshint ignore:line
  }
  _handleLocaleSelectorClick() {
    this._toggleAttribute('open');
  }
  _handleSelectedClick(e) {
    const t = e.currentTarget.dataset.value;
    t && this._setLocale(t, 'pt-br', 'setLocale'),
      this._toggleAttribute('open'); // jshint ignore:line
  }
  _valueChanged(e) {
    this.dispatchEvent(
      new CustomEvent('change', {
        bubbles: !0,
        composed: !0,
        detail: {
          value: e,
        },
      })
    );
  }
  _findOption(e) {
    // Verificar se _options existe e é um array antes de fazer find
    if (!this._options || !Array.isArray(this._options) || !e) {
      return null;
    }

    return this._options.find(t => t && t.value === e);
  }
  _getLocaleSelectorItemClass(e, t) {
    let a = 'cs-locale-selector__item';

    // Verificar se ambos os parâmetros existem e são válidos
    if (e && e.value && t && typeof e.value === 'string' && typeof t === 'string') {
      if (e.value.toLowerCase() === t.toLowerCase()) {
        a = `${a} ${a}-current`;
      }
    }

    return a;
  }
  _getOptions() {
    // Verificar se a função 'a' existe antes de usar
    if (!a || typeof a !== 'function') {
      return [];
    }

    const e = a(this, ['locale-selector-option']);

    // Verificar se e é um array antes de mapear
    if (!e || !Array.isArray(e)) {
      return [];
    }

    return e.map(e => ({
      value: e.getAttribute('value') || '',
      text: e.textContent || '',
      disabled: e.hasAttribute('disabled'),
    }));
  }
  _setOptions() {
    const options = this._getOptions();
    this.set('_options', options);
  }
  _tapHandler(e) {
    const t = r(e.target, this.nodeName);
    this.open && (!t || t !== this) && (this.open = !1); // jshint ignore:line
  }
  _onSelectChange(e) {
    const t = e.target.value;
    this.value !== t && this._setLocale(t, 'pt-br', 'setLocale'); // jshint ignore:line
  }
  _updateSelect(e) {
    this._clearChildren(this.$.select),
      this._addOptionsToSelect(e, this.$.select); // jshint ignore:line
  }
  _clearChildren(e) {
    for (; e.firstChild; ) e.removeChild(e.firstChild);
  }
  _addOptionsToSelect(e, t) {
    const a = document.createDocumentFragment();
    e.forEach(e => {
      const t = document.createElement('option');
      (t.textContent = e.text),
        t.classList.add('cs-locale-selector'),
        t.setAttribute('value', e.value),
        e.value === this.value && t.setAttribute('selected', ''),
        e.disabled && t.setAttribute('disabled', ''),
        a.appendChild(t); // jshint ignore:line
    }),
      t.appendChild(a); // jshint ignore:line
  }
  connectedCallback() {
    super.connectedCallback();

    // Aguardar o próximo frame para garantir que o DOM esteja pronto
    requestAnimationFrame(() => {
      this._setOptions();
    });

    Gestures.addListener(document, 'tap', this._tapHandler);

    // Verificar se shadowRoot existe antes de adicionar event listener
    if (this.shadowRoot) {
      this.shadowRoot.addEventListener('slotchange', this._setOptions);
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();

    // Corrigir: usar document em vez de this para removeListener
    Gestures.removeListener(document, 'tap', this._tapHandler);

    // Verificar se shadowRoot existe antes de remover event listener
    if (this.shadowRoot) {
      this.shadowRoot.removeEventListener('slotchange', this._setOptions);
    }
  }
}

customElements.define('cs-locale-selector', CsLocaleSelector);
